import Breadcrumb from "../Breadcrumb";
import { TopBarActions } from "./TopBarActions";

interface TopBarProps {
	searchQuery?: string;
	onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	hideSearch?: boolean;
}

export const TopBar = ({
	searchQuery = "",
	onSearchChange,
	hideSearch,
}: TopBarProps) => {
	return (
		<div className="bg-bg-primary border-b border-border-secondary px-7 py-3 flex items-center justify-between gap-4 h-14 flex-shrink-0">
			{/* Page Title / Breadcrumb */}
			<div className="flex-1">
				<Breadcrumb />
			</div>

			{/* Right side controls */}
			<TopBarActions
				searchQuery={searchQuery}
				onSearchChange={onSearchChange}
				hideSearch={hideSearch}
			/>
		</div>
	);
};
